<template>
  <v-navigation-drawer v-if="localIsMenuOpen" :class="['mobile-nav w-75', { 'is-open': localIsMenuOpen }]"
    v-model="localIsMenuOpen" :location="$vuetify.display.mobile ? 'left' : undefined" temporary color="borderGrey">
    <div class="navigation-draver-items">
      <div v-if="token" class="d-flex align-center spacer">
        <div class="me-2">
          <img loading="lazy" v-if="userInfo.photo" :alt="'Avatar'" :src="userInfo.photo" />
          <svg-icon  v-else type="mdi" :path="path" color="gray" variant="text"></svg-icon>
        </div>
        <div>
          <strong v-html="getUserFullName ? getUserFullName : ''"></strong>
        </div>
      </div>

      <div v-if="token" v-for="(route, index) in profileRoutes" :key="index">
        <div v-if="route.text != 'Bildirimler'" class="w-100 route hover-color-primary hover-bigger cursor-pointer d-flex align-center justify-start h-100">
          <nuxt-link :to="route.route" activeClass="active" class="d-flex align-center">
            <svg-icon type="mdi" :path="route.icon" class="mr-4" color="gray" variant="text"></svg-icon>
            <span>{{ route.text }}</span>
          </nuxt-link>
        </div>
      </div>
      <v-divider v-if="token"></v-divider>
      <div v-for="(route, index) in routes" :key="index">
        <div class="w-100 route hover-color-primary hover-bigger cursor-pointer">

          <nuxt-link :to="route.link" :target="route.name === 'Blog' ? '_blank' : '_self'"
            :rel="route.name === 'Blog' ? 'noopener noreferrer' : null" activeClass="active" class="d-flex align-center">
            <svg-icon type="mdi" :path="route.icon" class="mr-4" color="gray" variant="text"></svg-icon>
            {{ route.name }}
          </nuxt-link>
        </div>
      </div>
      <div class="buttons" v-if="!token">
        <v-btn variant="flat" block size="x-large" color="white" to="/giris-yap">Giriş Yap</v-btn>
        <v-btn variant="flat" block size="x-large" color="primary" to="/uye-ol">Kayıt Ol</v-btn>
        <v-btn color="white" class="google-btn divissa-btn" @click="handleGoogleLogin" :loading="isLoading">
          <template v-slot:prepend>
            <img loading="lazy" src="~/assets/images/google-icon.svg" height="32" alt="" />
          </template>
          Google ile Giriş Yap
        </v-btn>
      </div>
      <div class="buttons" v-else>
        <v-btn variant="flat" block size="x-large" color="error" @click="logout">Çıkış Yap</v-btn>
      </div>
    </div>
  </v-navigation-drawer>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { mapState } from "pinia";
import { headerRoutes } from "~/utils/routes";
import SvgIcon from '@jamescoyle/vue-icon';

import { mdiAccount } from '@mdi/js';
import { GoogleAuthProvider, signInWithPopup } from "firebase/auth";
export default defineComponent({
  name: "loggedInMobile",
  components: {
    SvgIcon
  },
  data() {
    return {
      isLoading: false as boolean,
      routes: headerRoutes,
      panel: ["profil", "sayfalar"],
      isReady: false as boolean,
      localIsMenuOpen: false,
      path: mdiAccount,
    };
  },
  computed: {
    ...mapState(useMyUserStore, [
      "userInfo",
      "getUserFullName",
      "getProfileRoutes",
    ]),
    ...mapState(useMyCommonStore, ["getIsMenuOpened"]),

    isMenuOpen() {
      if (typeof window !== "undefined") {
        return this.getIsMenuOpened;
      }
    },
    profileRoutes(): Array<{ id: number; route: string; text: string; icon: string }> {
      return this.getProfileRoutes;
    },

    ...mapState(useMyUserStore, ["token"]),
  },
  created() {

  },
  mounted() { },
  methods: {
    async handleGoogleLogin() {
      this.isLoading = true;
      try {
        const { $firebase } = this.$nuxt;
        const auth = $firebase.auth;
        const provider = new GoogleAuthProvider();

        const result = await signInWithPopup(auth, provider);
        const credential = GoogleAuthProvider.credentialFromResult(result);

        const token = (auth?.currentUser as any)?.stsTokenManager?.accessToken;
        const useStore = useMyUserStore();
        const body = { idToken: token };
        useStore.LoginWithFireBase(body);
      } catch (error) {
        console.error('Error during Google sign-in:', error);
      } finally {
        this.isLoading = false;
      }
    },
    logout() {
      const useStore = useMyUserStore();
      useStore.Logout();
    },
    toggleIsMenuOpen() {
      const useCommonStore = useMyCommonStore();
      useCommonStore.toggleIsMenuOpen();
    },
  },
  watch: {
    localIsMenuOpen(newVal) {
      if (newVal !== this.getIsMenuOpened) {
        this.toggleIsMenuOpen();
      }
    },
    isMenuOpen(newVal) {
      this.localIsMenuOpen = newVal;
    },
  },
});
</script>

<style scoped>
.active {
  font-weight: bold;
}
</style>
